/**
 * Table row for a per-return outcome in a bulk RMA action request.
 */
import { useNavigate } from 'react-router-dom';

import FontBody2 from '../../../../../../components/fonts/font-body2/font-body2';
import { FONT_COLOR, FONT_VARIANT } from '../../../../../../components/fonts/font-props';
import TableRow from '../../../../../../components/table/components/table-row/table-row';
import { Tooltip, TOOLTIP_VARIANTS } from '../../../../../../components/tooltip/tooltip';
import { TOOLTIP_PLACEMENTS } from '../../../../../../components/tooltip/tooltip-box';
import { APP_PATHS } from '../../../../../../constants/app-paths';
import { IBulkRmaActionReturnRow } from '../../../../../../services/api/troubleshooting-service';
import { RETURN_STATUS_LABELS } from '../../utils/bulk-rma-action-labels';
import BulkRmaStatusChip from '../bulk-rma-status-chip/bulk-rma-status-chip';

interface IReturnTableRowProps {
    row: IBulkRmaActionReturnRow;
}

const ReturnTableRow: React.FC<IReturnTableRowProps> = ({ row }) => {
    const navigate = useNavigate();
    const reasonMessage = row.reason_message ?? '—';

    const cells = [
        <span
            className="bulk-rma-actions-page__rma-link"
            onClick={() => navigate({ pathname: `${APP_PATHS.RETURNS}/${row.rma_id}` })}
        >
            <FontBody2 color={FONT_COLOR.ACCENT1} variant={FONT_VARIANT.UNDER_LINE}>
                {`#${row.rma_id}`}
            </FontBody2>
        </span>,
        <BulkRmaStatusChip
            status={row.status}
            label={RETURN_STATUS_LABELS[row.status] ?? row.status}
        />,
        <FontBody2>{row.reason_code ?? '—'}</FontBody2>,
        <FontBody2>{row.job_id ?? '—'}</FontBody2>,
        <Tooltip
            content={
                row.reason_message
                    ? (
                        <FontBody2 color={FONT_COLOR.NEUTRAL_WHITE}>
                            {row.reason_message}
                        </FontBody2>
                    )
                    : null
            }
            placement={TOOLTIP_PLACEMENTS.LEFT}
            variant={TOOLTIP_VARIANTS.INFO}
        >
            <span className="bulk-rma-actions-page__ellipsis">
                <FontBody2>{reasonMessage}</FontBody2>
            </span>
        </Tooltip>,
    ];

    return (
        <TableRow
            name={`bulk-return-${row.id}`}
            skipWrapingCell
            cells={cells}
        />
    );
};

export default ReturnTableRow;
